import React from 'react';
import { Card, Box, Typography } from '@mui/material';
import { COLOR, FUENTE, FUENTE_MONO } from './tokens';

const COLOR_SEVERIDAD = { bad: COLOR.rojo, warn: COLOR.ambar, info: COLOR.azulClaro };

/**
 * Acciones sugeridas — una tarjeta por umbral realmente incumplido (calculado en
 * selectors.calcularAcciones, nunca escrito a mano acá). Si el umbral no se cumple,
 * la tarjeta directamente no aparece.
 * @param {{items: Array<{title: string, text: string, rule: string, severity: 'bad'|'warn'|'info'}>}} props
 */
const AccionesSugeridas = ({ items }) => {
    if (!items?.length) {
        return (
            <Card variant="outlined" sx={{ border: '1px solid #e2e8f0', borderRadius: '12px', boxShadow: 'none', padding: '20px 22px' }}>
                <Typography sx={{ fontFamily: FUENTE, fontSize: 16, fontWeight: 700, color: COLOR.negro }}>Acciones sugeridas</Typography>
                <Typography sx={{ fontFamily: FUENTE, fontSize: 13, color: COLOR.grisTexto, marginTop: '8px' }}>
                    Ningún umbral del sistema está incumplido en el período seleccionado.
                </Typography>
            </Card>
        );
    }
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {items.map((item) => (
                <Card key={item.title} variant="outlined" sx={{
                    border: '1px solid #e2e8f0', borderRadius: '10px', boxShadow: 'none',
                    padding: '14px 16px', display: 'flex', gap: '12px',
                }}>
                    <Box sx={{ width: 3, flexShrink: 0, borderRadius: 2, background: COLOR_SEVERIDAD[item.severity] || COLOR.grisFrio }} />
                    <Box sx={{ flex: 1 }}>
                        <Typography sx={{ fontFamily: FUENTE, fontSize: 14, fontWeight: 700, color: COLOR.negro }}>{item.title}</Typography>
                        <Typography sx={{ fontFamily: FUENTE, fontSize: 12.5, color: COLOR.grisTexto, lineHeight: 1.5, marginTop: '2px' }}>
                            {item.text}
                        </Typography>
                        <Typography sx={{ fontFamily: FUENTE_MONO, fontSize: 11, color: COLOR.grisFrio, marginTop: '6px' }}>
                            {item.rule}
                        </Typography>
                    </Box>
                </Card>
            ))}
        </Box>
    );
};

export default AccionesSugeridas;
